import "./Footer.scss";

import { ReactComponent as TelegramIcon } from "../../assets/icons/Telegram.svg";
import { ReactComponent as XLogo } from "../../assets/icons/XLogo.svg";
import { ReactComponent as MediumIcon } from "../../assets/icons/Medium.svg";
import { ReactComponent as GitbookIcon } from "../../assets/icons/Gitbook.svg";

import FooterLeft from "../../assets/images/footer-left.png";
import FooterRight from "../../assets/images/footer-right.png";

export default function Footer() {
	return (
		<div className="footer" id="footer">
			<div className="footer-content-wrap content-wrapper-lg">
				<img src={FooterLeft} alt="Footer Left" className="img-footer-left decoration" />
				<img src={FooterRight} alt="Footer Right" className="img-footer-right decoration" />

				<div className="footer-content">
					<div className="footer-links-wrapper">
						<ul className="footer-links">
							<li>
								<div className="footer-link">
									<a href="https://t.me/gatrlabs">
										<TelegramIcon className="footer-link-icon" />
										Telegram
									</a>
								</div>
							</li>
							<li>
								<div className="footer-link">
									<a href="https://x.com/GatrLabs">
										<XLogo className="footer-link-icon" />X
										Platform
									</a>
								</div>
							</li>
							<li>
								<div className="footer-link">
									<a href="https://medium.com/@gatrlabs">
										<MediumIcon className="footer-link-icon" />
										Medium
									</a>
								</div>
							</li>
							<li>
								<div className="footer-link">
									<a href="https://atlas-20.gitbook.io/gatr/">
										<GitbookIcon className="footer-link-icon" />
										Gitbook
									</a>
								</div>
							</li>
						</ul>
					</div>

					<div className="footer-copyright">
						<p>
							Copyright © 2024 - 2025 GATR®. All rights reserved.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
